import { PlaceholderPage } from './PlaceholderPage';

export const IntegrationSettingsPage = () => <PlaceholderPage title="Integration Settings" />;
